import React, { Fragment, useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export function LayoutSortableItems(props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        handle,
        isDragging,
        setActivatorNodeRef
    } = useSortable({ id: props.id });



    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex:isDragging ? 3: null,
    };
    const cardImgPath = window.location.href.indexOf("vagaro.com") > 0 ? ("https://d396040dc4cf62cf5770-d11e112dbdab6afc64c448f17b56c3c3.ssl.cf2.rackcdn.com/WB/"):("https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/");

    const cardImgPlaceholder =
        "https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/styale-thum-empty.gif";


    return (
        <div ref={setNodeRef} style={style} className="styles-card-col" handle={handle}>
            <div className="styles-card">
                <div className="styles-card-thum-frame">
                    <span className="dots"></span>
                    <img className="styles-card-thum" 
                    alt={props.layoutTitle}
                    style={{ backgroundImage: `url('${cardImgPath + props.layoutImage}')` }}
                    src={cardImgPlaceholder} 
                    />
                    <div className="styles-card-overlay">
                    <button className="dragbutton" {...attributes} {...listeners}>
                        <i className="far fa-bars"></i>
                    </button>
                    <Dropdown className="moremenu dropdown size24">
                        <Dropdown.Toggle className="more-3dot">
                            <i
                                className="far fa-ellipsis-v"
                                aria-hidden="true"
                            />
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            <Dropdown.Item onClick={(e) => { props.UseLayout(props.id,true); }}>
                                Edit Layout
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => props.EditLayoutPopup(props.id, false)}>
                                Edit Layout Settings
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => props.DuplicateLayout(props.id)} >
                                Duplicate
                            </Dropdown.Item>
                            {props.isActive && props.isSoftDelete &&
                                <Dropdown.Item onClick={(e) => { props.ActivatelayoutPopup(props.id) }}>
                                    Activate
                                </Dropdown.Item>
                            }
                            {props.isActive && props.isSoftDelete == false &&
                                <Dropdown.Item onClick={(e) => { props.DeactivateLayoutPopup(props.id) }}>
                                    Deactivate
                                </Dropdown.Item>
                            }
                            <Dropdown.Item onClick={() => props.DeleteLayoutPopup(props.id)} >
                                Delete
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <div className="btn-row">
                        <a
                            onClick={(e) => { props.UseLayout(props.id) }}
                            className={"w-button w-button-primary layout-"+props.id}
                        >
                            Use Website Layout
                        </a>
                    </div>
                    <div className="btn-row">
                        <a
                            className="w-button w-button-ghost" onClick={(e) => props.ViewLayout(props.layoutImage, props.id)}
                        >
                            Preview
                        </a>
                    </div>
                </div>
                </div>
                <div className="styles-card-item">
                    <h3>{props.layoutTitle}{props.isActive && props.isSoftDelete &&
                        <span className="badge badge-secondary badge-inactive">
                            INACTIVE
                        </span>
                    }</h3>
                    <p>
                        {props.layoutDescription}
                    </p>
                </div>
                
            </div>
        </div>
    );

}

export default LayoutSortableItems;